import React from "react";
import classNames from "classnames";
import styles from "./MomentCard.module.css";
import skeletonStyles from "./MomentCardSkeleton.module.css";

export const MomentCardSkeleton = ({ className, ...props }) => {
  return (
    <div
      className={classNames(
        styles.card,
        skeletonStyles.skeletonCard,
        className,
      )}
      {...props}
    >
      <div className={styles.cardInner}>
        {/* Image Skeleton */}
        <div
          className={classNames(styles.image, skeletonStyles.skeletonImage)}
        />

        {/* Location and Date Band Skeleton */}
        <div className={styles.locationBand}>
          <div className={styles.locationContent}>
            <div
              className={classNames(
                styles.location,
                skeletonStyles.skeletonLocation,
              )}
            />
            <div
              className={classNames(
                styles.dateRange,
                skeletonStyles.skeletonDateRange,
              )}
            />
          </div>
        </div>

        {/* Content Section Skeleton */}
        <div className={styles.content}>
          <div
            className={classNames(styles.title, skeletonStyles.skeletonTitle)}
          />

          {/* Footer Skeleton */}
          <div className={styles.footer}>
            <div className={styles.packageInfo}>
              <span
                className={classNames(
                  styles.packageCount,
                  skeletonStyles.skeletonPackage,
                )}
              />
              <div className={styles.divider}>|</div>
              <span
                className={classNames(
                  styles.endDate,
                  skeletonStyles.skeletonEndDate,
                )}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
